/**
 * Username validation utility
 * 
 * Requirements:
 * - Minimum 4 characters
 * - Only lowercase letters (a-z) and digits (0-9)
 * - Allows usernames with 4 digits (e.g., "1234")
 * - UI may accept uppercase input, but usernames are stored and checked as lowercase
 * 
 * @param value - The username to validate
 * @returns true if the username is valid, false otherwise
 */
export const validateUsername = (value: string): boolean => {
  return /^[a-z0-9]{4,}$/.test(value);
};

export const normalizeUsername = (value: string): string => {
  return value.trim().toLowerCase();
};

